export default class BrowserIsSupported {
  constructor() {
    const agent = navigator.userAgent;
    let match;

    match = agent.match(/Chrome\/(\d+)/);
    if (match && parseInt(match[1]) >= 42) return true;

    match = agent.match(/Safari\/(\d+)/);
    if (match && parseInt(match[1]) >= 537) return true;

    match = agent.match(/Firefox\/(\d+)/);
    if (match && parseInt(match[1]) >= 50) return true;

    return false;
  }
}
